import React from "react";
import LargePopupRedirect from "../../_utils/CommonPopups/CommonLargePopupRedirect";
import OwnerAllStatement from "../../../containers/Accounts/OwnerAccount/OwnerAllStatement";
import ICONS from "../../../assets/Icons";

const ConsolidatedBankPopup = ({
  setViewstatementOpenPop,
  type,
  ownerDetailId,
}) => {
  return (
    <>
      {" "}
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle="Unmatch from consolidated bank statement "
          headersubtext="The following transactions are matched and need to be unmatched before rejecting this account."
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          fullviewdisabledBgColor="var(--text-disabled)"
          closeiconbtnType="button"
          closeiconhandleFunction={() => {
            setViewstatementOpenPop(false);
          }}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
          isscrollRequired={true}
        >
          <OwnerAllStatement
            popType={type}
            ownerDetailId={ownerDetailId}
            // ownerDetailData={ownerDetailData}
            setViewstatementOpenPop={setViewstatementOpenPop}
          />
        </LargePopupRedirect>
      </div>
    </>
  );
};

export default ConsolidatedBankPopup;
